import ContextMenuEntry from '~/components/ContextMenuEntry';
import ArchiveIcon from '~/icons/ArchiveIcon';
import CheckIcon from '~/icons/CheckIcon';
import CopyIcon from '~/icons/CopyIcon';
import DownloadIcon from '~/icons/DownloadIcon';
import EditIcon from '~/icons/EditIcon';
import LinkIcon from '~/icons/LinkIcon';
import SendIcon from '~/icons/SendIcon';
import TrashIcon from '~/icons/TrashIcon';
import { copyToClipboard, openInNewTab } from '~/utils/utils';
import { useInvoiceListContext } from '../hooks/useInvoiceListContext';
import AddClientModal from '../../Client/AddClient/AddClientModal';
import SendInvoiceModal from '../SendInvoiceModal';
import { useState } from 'react';

interface IInvoiceContextMenuProps {
  invoiceReferenceId: string;
}

const InvoiceContextMenu = ({ invoiceReferenceId }: IInvoiceContextMenuProps) => {
  const { listData, onOpenDeleteInvoiceModal, onEditInvoice, onEditListInvoice, onCloneInvoice } =
    useInvoiceListContext();
  const thisInvoiceData = listData[invoiceReferenceId];
  const publicLink = `${process.env.LANDING_PAGE_URL}/shared/${thisInvoiceData.invoice_uuid}/`;

  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);

  function handleCloseClientModal() {
    setIsClientModalOpen(false);
  }

  function handleOpenClientModal() {
    setIsClientModalOpen(true);
  }

  function handleCloseSendModal() {
    setIsSendModalOpen(false);
  }

  function handleOpenSendModal() {
    setIsSendModalOpen(true);
  }

  return (
    <>
      <AddClientModal
        isModalOpen={isClientModalOpen}
        onCloseClientModal={handleCloseClientModal}
        heading="Edit Client"
        clientId={thisInvoiceData.client_uuid}
      />
      <SendInvoiceModal
        isModalOpen={isSendModalOpen}
        onCloseModal={handleCloseSendModal}
        invoiceUuid={thisInvoiceData.invoice_uuid}
        onOpenClientModal={handleOpenClientModal}
        successCallback={() => {
          onEditListInvoice(invoiceReferenceId, { status: 'Sent' });
        }}
      />
      <ContextMenuEntry
        sections={[
          {
            key: 'invoice',
            options: [
              {
                text: 'Edit Invoice',
                onClick: () => {
                  onEditInvoice(invoiceReferenceId);
                },
                isEnabled:
                  thisInvoiceData.payment_status !== 'Paid' && thisInvoiceData.archived === false,
                icon: <EditIcon />,
              },
              {
                text: 'Mark as Sent',
                isVisible: thisInvoiceData.status === 'Draft' && thisInvoiceData.archived === false,
                onClick: () => {
                  onEditListInvoice(invoiceReferenceId, { status: 'Sent' });
                },
                icon: <CheckIcon />,
              },
              {
                text: 'Email Invoice',
                isVisible: thisInvoiceData.archived === false,
                onClick: handleOpenSendModal,
                icon: <SendIcon size={18} />,
              },
              {
                text: 'Mark as Paid',
                isVisible:
                  thisInvoiceData.status === 'Sent' && thisInvoiceData.payment_status !== 'Paid',
                onClick: () => {
                  onEditListInvoice(invoiceReferenceId, { payment_status: 'Paid' });
                },
                icon: <CheckIcon />,
              },
              {
                text: 'Copy Invoice Link',
                onClick: () => {
                  copyToClipboard(publicLink, 'Invoice link copied to clipboard');
                },
                icon: <LinkIcon />,
                isVisible: thisInvoiceData.archived === false,
              },
              {
                text: 'Download as PDF',
                onClick: () => {
                  openInNewTab(thisInvoiceData.pdf_url);
                },
                icon: <DownloadIcon />,
              },
              {
                text: 'Clone Invoice',
                onClick: () => {
                  onCloneInvoice(invoiceReferenceId);
                },
                icon: <CopyIcon size={18} />,
              },
            ],
          },

          {
            key: 'danger-invoice',
            options: [
              {
                text: 'Archive',
                onClick: () => {
                  onEditListInvoice(invoiceReferenceId, { archived: true });
                },
                color: 'danger',
                icon: <ArchiveIcon />,
                isVisible: thisInvoiceData.archived === false,
              },
              {
                text: 'Delete',
                onClick: () => {
                  onOpenDeleteInvoiceModal(invoiceReferenceId);
                },
                color: 'danger',
                icon: <TrashIcon />,
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default InvoiceContextMenu;
